import React from 'react'
import Input from './Input'
import { IconButton, InputAdornment } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

/**
 * Componente requiere el uso de react-hook-form para generar
 * el prop control.
 * Abstracion de Input para generar un campo de contraseña con
 * boton para ocultar y mostrar la contraseña.
 * Informacion de _props en el componente <Input/>
 * @param {*} _props
 * @returns {JSX}
 */
function PasswordInput(_props) {
  const { validation, ...rest } = _props
  const [showPassword, setShowPassword] = React.useState(false)

  function handleClickShowPassword() {
    setShowPassword(!showPassword)
  }

  return (
    <Input
      {...rest}
      validation={{
        ...validation,
        maxLength: {
          value: 100,
          message: 'La contraseña no puede tener mas de 100 caracteres',
        },
      }}
      type={showPassword ? 'text' : 'password'}
      endAdornment={
        <InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            edge="end"
          >
            {!showPassword ? (
              <FontAwesomeIcon icon={faEye} size="1x" />
            ) : (
              <FontAwesomeIcon icon={faEyeSlash} size="1x" />
            )}
          </IconButton>
        </InputAdornment>
      }
    />
  )
}

export default PasswordInput
